import style from "./Logo.module.scss";

export default function Logo({ className = "" }) {
  return (
    <div className={`d-flex align-items-center ${className}`}>
      <img className={`${style.brandLogo} d-block`} src={`${process.env.PUBLIC_URL}/images/lushai_logo.svg`} alt="Lushai tech logo"/>
    </div>
  )
}